"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionTypeName = exports.TransactionStatusName = void 0;
exports.TransactionStatusName = {
    REQUESTED: 'En proceso',
    UNCONFIRMED: 'Por confirmar',
    ON_HOLD: 'Por firmar',
    REJECTED: 'Rechazado',
    CONFIRMED: 'Confirmado',
    COMPLETED: 'Completado',
};
exports.transactionTypeName = {
    BUY: 'Suscripción',
    SELL: 'Rescate',
};
//# sourceMappingURL=transactions.js.map